module.exports = __webpack_public_path__ + "img/features-split-image.ce83ce96.svg";